import {
  AppBar,
  Box,
  Button,
  Container,
  CssBaseline,
  Grid,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Paper,
  Toolbar,
  Typography,
  useScrollTrigger,
  useTheme,
} from "@mui/material";
import { useAppSelector } from "../../../../../hooks/store-hooks";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import BarChartIcon from "@mui/icons-material/BarChart";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import SchoolIcon from "@mui/icons-material/School";
import WcIcon from "@mui/icons-material/Wc";
import CreditScoreIcon from "@mui/icons-material/CreditScore";
import BadgeIcon from "@mui/icons-material/Badge";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
import ContactPhoneIcon from "@mui/icons-material/ContactPhone";
import SupervisedUserCircleIcon from "@mui/icons-material/SupervisedUserCircle";
import PersonOffIcon from "@mui/icons-material/PersonOff";
import AssignmentIcon from '@mui/icons-material/Assignment';
import { useProjetosService } from "../../../../../../use-cases/geo-veles";
import { FiltroLocalizacao } from "./localizacao";
import { FiltroSexo } from "./sexo";
import { FiltroIdade } from "./idade";
import { FiltroRendaPresumida } from "./renda-presumida";
import { FiltroClasseSocial } from "./classe-social";
import { FiltroEscolaridade } from "./escolaridade";
import { FiltroScore } from "./score";
import { FiltroContatos } from "./contatos";
import { FiltroEstadoCivil } from "./estado-civil";
import { RelatorioProjeto } from "../relatorio-projeto";
import { FiltroCBO } from "./cbo";
import { FiltroProfissao } from "./profissao";
import { FiltroListaDeduplicacao } from "./lista-deduplicacao";
import { FiltroSituacaoCadastral } from "./situacao-cadastral";
import React from "react";

interface Props {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window?: () => Window;
  children: React.ReactElement<{ elevation?: number }>;
}

// function HideOnScroll(props: Props) {
//   const trigger = useScrollTrigger();
//   return (
//     <Slide in={!trigger}>
//       <div>Hello</div>
//     </Slide>
//   );
// }

function ElevationScroll(props: Props) {
  const { children, window } = props;
  // Note that you normally won't need to set the window ref as useScrollTrigger
  // will default to window.
  // This is only being set here because the demo is in an iframe.
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0,
    target: window ? window() : undefined,
  });

  return React.cloneElement(children, {
    elevation: trigger ? 4 : 0,
  });
}

export function ElevateAppBar(props: Props & { children?: React.ReactNode }) {
  const nomeProj = useAppSelector(
    (state) => state.projetos?.projetoAberto?.Nome
  );
  const { resetProjetoAberto } = useProjetosService();

  return (
    <React.Fragment>
      <CssBaseline />
      <ElevationScroll {...props}>
        <AppBar sx={{ position: "absolute" }}>
          <Toolbar>
            <Typography
              sx={{ ml: 2, flex: 1 }}
              textTransform={"uppercase"}
              fontWeight={"bold"}
              variant="h6"
              component="div"
            >
              {nomeProj ?? ""}
            </Typography>
            <Button
              color="inherit"
              onClick={() => resetProjetoAberto()}
              aria-label="close"
              sx={{
                fontWeight: "bold",
              }}
            >
              Fechar
            </Button>
          </Toolbar>
        </AppBar>
      </ElevationScroll>
      <Toolbar />
      <Container>
        <Box sx={{ my: 2, maxHeight: "100%", overflowY: "scroll" }}>
          {/* {[...new Array(12)]
            .map(
              () => ,
            )
            .join('\n')} */}
          {props.children} {/* Aqui renderiza os itens passados via children */}
        </Box>
      </Container>
    </React.Fragment>
  );
}

export const Filtros = () => {
  // State
  // Hook
  const { setProjetoFiltroAtivo, resetFiltros } = useProjetosService();
  const theme = useTheme();
  const { filtroAtivo, relatorioProjeto } = useAppSelector(
    (state) => state.projetos
  );

  return (
    <>
      <Box
        style={{
          marginBottom: "80px",
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={3}>
            <Box
              sx={{
                position: 'sticky',
                top: '80px',
                overflowY: 'auto',
                paddingRight: '8px',
                paddingBottom: '20px',
                height: 'calc(100vh - 80px)',
              }}
            >
              {/* <ElevateAppBar> */}
              <List>
                <ListItem key={0}>
                  <Paper
                    elevation={3}
                    style={{
                      width: "100%",
                    }}
                  >
                    <ListItemButton
                      onClick={() => setProjetoFiltroAtivo(0)}
                      style={{
                        background:
                          filtroAtivo === 0 ? theme.palette.primary.main : "",
                        color: filtroAtivo === 0 ? "white" : "black",
                      }}
                    >
                      <ListItemIcon>
                        <LocationOnIcon
                          style={{
                            color: filtroAtivo === 0 ? "white" : "black",
                          }}
                        />
                      </ListItemIcon>
                      <ListItemText
                        primary={"Localização / Geolocalização".toUpperCase()}
                      />
                    </ListItemButton>
                  </Paper>
                </ListItem>
                <ListItem key={1}>
                  <Paper
                    elevation={3}
                    style={{
                      width: "100%",
                    }}
                  >
                    <ListItemButton
                      onClick={() => setProjetoFiltroAtivo(1)}
                      style={{
                        background:
                          filtroAtivo === 1 ? theme.palette.primary.main : "",
                        color: filtroAtivo === 1 ? "white" : "black",
                      }}
                    >
                      <ListItemIcon>
                        <WcIcon
                          style={{
                            color: filtroAtivo === 1 ? "white" : "black",
                          }}
                        />
                      </ListItemIcon>
                      <ListItemText primary={"Sexo".toUpperCase()} />
                    </ListItemButton>
                  </Paper>
                </ListItem>
                <ListItem key={2}>
                  <Paper elevation={3} style={{ width: "100%" }}>
                    <ListItemButton
                      onClick={() => setProjetoFiltroAtivo(2)}
                      style={{
                        background:
                          filtroAtivo === 2 ? theme.palette.primary.main : "",
                        color: filtroAtivo === 2 ? "white" : "black",
                      }}
                    >
                      <ListItemIcon>
                        <CalendarMonthIcon
                          style={{
                            color: filtroAtivo === 2 ? "white" : "black",
                          }}
                        />
                      </ListItemIcon>
                      <ListItemText primary={"Idade".toUpperCase()} />
                    </ListItemButton>
                  </Paper>
                </ListItem>

                <ListItem key={3}>
                  <Paper elevation={3} style={{ width: "100%" }}>
                    <ListItemButton
                      onClick={() => setProjetoFiltroAtivo(3)}
                      style={{
                        background:
                          filtroAtivo === 3 ? theme.palette.primary.main : "",
                        color: filtroAtivo === 3 ? "white" : "black",
                      }}
                    >
                      <ListItemIcon>
                        <MonetizationOnIcon
                          style={{
                            color: filtroAtivo === 3 ? "white" : "black",
                          }}
                        />
                      </ListItemIcon>
                      <ListItemText primary={"Renda Presumida".toUpperCase()} />
                    </ListItemButton>
                  </Paper>
                </ListItem>

                <ListItem key={4}>
                  <Paper elevation={3} style={{ width: "100%" }}>
                    <ListItemButton
                      onClick={() => setProjetoFiltroAtivo(4)}
                      style={{
                        background:
                          filtroAtivo === 4 ? theme.palette.primary.main : "",
                        color: filtroAtivo === 4 ? "white" : "black",
                      }}
                    >
                      <ListItemIcon>
                        <BarChartIcon
                          style={{
                            color: filtroAtivo === 4 ? "white" : "black",
                          }}
                        />
                      </ListItemIcon>
                      <ListItemText primary={"Classe Social".toUpperCase()} />
                    </ListItemButton>
                  </Paper>
                </ListItem>

                <ListItem key={5}>
                  <Paper elevation={3} style={{ width: "100%" }}>
                    <ListItemButton
                      onClick={() => setProjetoFiltroAtivo(5)}
                      style={{
                        background:
                          filtroAtivo === 5 ? theme.palette.primary.main : "",
                        color: filtroAtivo === 5 ? "white" : "black",
                      }}
                    >
                      <ListItemIcon>
                        <SchoolIcon
                          style={{
                            color: filtroAtivo === 5 ? "white" : "black",
                          }}
                        />
                      </ListItemIcon>
                      <ListItemText primary={"Escolaridade".toUpperCase()} />
                    </ListItemButton>
                  </Paper>
                </ListItem>

                <ListItem key={6}>
                  <Paper elevation={3} style={{ width: "100%" }}>
                    <ListItemButton
                      onClick={() => setProjetoFiltroAtivo(6)}
                      style={{
                        background:
                          filtroAtivo === 6 ? theme.palette.primary.main : "",
                        color: filtroAtivo === 6 ? "white" : "black",
                      }}
                    >
                      <ListItemIcon>
                        <AssignmentIcon
                          style={{
                            color: filtroAtivo === 6 ? "white" : "black",
                          }}
                        />
                      </ListItemIcon>
                      <ListItemText
                        primary={"Situação Cadastral".toUpperCase()}
                      />
                    </ListItemButton>
                  </Paper>
                </ListItem>

                <ListItem key={7}>
                  <Paper elevation={3} style={{ width: "100%" }}>
                    <ListItemButton
                      onClick={() => setProjetoFiltroAtivo(7)}
                      style={{
                        background:
                          filtroAtivo === 7 ? theme.palette.primary.main : "",
                        color: filtroAtivo === 7 ? "white" : "black",
                      }}
                    >
                      <ListItemIcon>
                        <CreditScoreIcon
                          style={{
                            color: filtroAtivo === 7 ? "white" : "black",
                          }}
                        />
                      </ListItemIcon>
                      <ListItemText
                        primary={"Saúde Financeira".toUpperCase()}
                      />
                    </ListItemButton>
                  </Paper>
                </ListItem>

                <ListItem key={8}>
                  <Paper elevation={3} style={{ width: "100%" }}>
                    <ListItemButton
                      onClick={() => setProjetoFiltroAtivo(8)}
                      style={{
                        background:
                          filtroAtivo === 8 ? theme.palette.primary.main : "",
                        color: filtroAtivo === 8 ? "white" : "black",
                      }}
                    >
                      <ListItemIcon>
                        <BadgeIcon
                          style={{
                            color: filtroAtivo === 8 ? "white" : "black",
                          }}
                        />
                      </ListItemIcon>
                      <ListItemText primary={"CBO".toUpperCase()} />
                    </ListItemButton>
                  </Paper>
                </ListItem>

                <ListItem key={9}>
                  <Paper elevation={3} style={{ width: "100%" }}>
                    <ListItemButton
                      onClick={() => setProjetoFiltroAtivo(9)}
                      style={{
                        background:
                          filtroAtivo === 9 ? theme.palette.primary.main : "",
                        color: filtroAtivo === 9 ? "white" : "black",
                      }}
                    >
                      <ListItemIcon>
                        <WorkOutlineIcon
                          style={{
                            color: filtroAtivo === 9 ? "white" : "black",
                          }}
                        />
                      </ListItemIcon>
                      <ListItemText primary={"Profissão".toUpperCase()} />
                    </ListItemButton>
                  </Paper>
                </ListItem>

                <ListItem key={10}>
                  <Paper elevation={3} style={{ width: "100%" }}>
                    <ListItemButton
                      onClick={() => setProjetoFiltroAtivo(10)}
                      style={{
                        background:
                          filtroAtivo === 10 ? theme.palette.primary.main : "",
                        color: filtroAtivo === 10 ? "white" : "black",
                      }}
                    >
                      <ListItemIcon>
                        <ContactPhoneIcon
                          style={{
                            color: filtroAtivo === 10 ? "white" : "black",
                          }}
                        />
                      </ListItemIcon>
                      <ListItemText primary={"Contatos".toUpperCase()} />
                    </ListItemButton>
                  </Paper>
                </ListItem>

                <ListItem key={11}>
                  <Paper elevation={3} style={{ width: "100%" }}>
                    <ListItemButton
                      onClick={() => setProjetoFiltroAtivo(11)}
                      style={{
                        background:
                          filtroAtivo === 11 ? theme.palette.primary.main : "",
                        color: filtroAtivo === 11 ? "white" : "black",
                      }}
                    >
                      <ListItemIcon>
                        <SupervisedUserCircleIcon
                          style={{
                            color: filtroAtivo === 11 ? "white" : "black",
                          }}
                        />
                      </ListItemIcon>
                      <ListItemText primary={"Estado Civil".toUpperCase()} />
                    </ListItemButton>
                  </Paper>
                </ListItem>

                <ListItem key={12}>
                  <Paper elevation={3} style={{ width: "100%" }}>
                    <ListItemButton
                      onClick={() => setProjetoFiltroAtivo(12)}
                      style={{
                        background:
                          filtroAtivo === 12 ? theme.palette.primary.main : "",
                        color: filtroAtivo === 12 ? "white" : "black",
                      }}
                    >
                      <ListItemIcon>
                        <PersonOffIcon
                          style={{
                            color: filtroAtivo === 12 ? "white" : "black",
                          }}
                        />
                      </ListItemIcon>
                      <ListItemText primary={"Deduplicação".toUpperCase()} />
                    </ListItemButton>
                  </Paper>
                </ListItem>
              </List>

              {/* </ElevateAppBar> */}
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box p={2}>
              {filtroAtivo === 0 ? (
                <FiltroLocalizacao />
              ) : filtroAtivo === 1 ? (
                <FiltroSexo />
              ) : filtroAtivo === 2 ? (
                <FiltroIdade />
              ) : filtroAtivo === 3 ? (
                <FiltroRendaPresumida />
              ) : filtroAtivo === 4 ? (
                <FiltroClasseSocial />
              ) : filtroAtivo === 5 ? (
                <FiltroEscolaridade />
              ) : filtroAtivo === 6 ? (
                <FiltroSituacaoCadastral />
              ) : filtroAtivo === 7 ? (
                <FiltroScore />
              ) : filtroAtivo === 8 ? (
                <FiltroCBO />
              ) : filtroAtivo === 9 ? (
                <FiltroProfissao />
              ) : filtroAtivo === 10 ? (
                <FiltroContatos />
              ) : filtroAtivo === 11 ? (
                <FiltroEstadoCivil />
              ) : filtroAtivo === 12 ? (
                <FiltroListaDeduplicacao />
              ) : null}
            </Box>
          </Grid>
          <Grid item xs={3}>
            <Box m={3}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    onClick={() => {
                      resetFiltros();
                    }}
                  >
                    Redefinir filtros
                  </Button>
                </Grid>
                <Grid item xs={12}>
                  {relatorioProjeto ? (
                    <>
                      <RelatorioProjeto />
                    </>
                  ) : (
                    <>
                      <Typography
                        variant="h6"
                        component="h6"
                        style={{
                          textAlign: "center",
                          marginTop: "20px",
                        }}
                      >
                        Para gerar um relatório, clique no botão "Atualizar".
                      </Typography>
                    </>
                  )}
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};
